import React from "react";
import PropTypes from "prop-types";
import { ThingsToDoCards } from "../../components/ExcursionPage/ThingsToDo/Cards";
import { useNexusFetchHook } from "../../utils/useNexusFetchHook";

const ThingsToDoConnector = ({ destinationCode }) => {
	const { excursionCardData } = useNexusFetchHook({
		destinationCode,
		isDetailsModal: true,
	});

	return <ThingsToDoCards cards={excursionCardData} />;
};

ThingsToDoConnector.propTypes = {
	destinationCode: PropTypes.string.isRequired,
};

export { ThingsToDoConnector };
